"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Modal = _interopRequireDefault(require("./Modal"));

exports.default = _Modal.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/modules/Modal/index.js
// module id = 613
// module chunks = 0